<template>
  <div>
    <div class="vld-parent">
        <loading loader='bars' :active.sync="isLoading" 
        :can-cancel="true" 
        :is-full-page="isFullPage">
        </loading>
    </div>
    <div class="page-header clear-filter">
    </div>
    
    <!-- login-and-otp-screen-start -->
    <div v-if="isMobCardShow" class="container loginAndOtp">
      <div class="row">
        <div class="col-12 col-sm-3 col-md-3"></div>
        <div class="col-12 col-sm-6 col-md-6">
          <!-- login-screen-start -->
          <div v-if="isSignUp === false">

            <h3 class="login-section"> LOGIN </h3>
            <form class="login-form">
              <div class="form-group">
                <float-label>
                <span class="input-group-addon">+91</span>
                <input 
                    id="mobile"  
                    v-model="mobile"
                    required 
                    oninput="javascript: if (this.value.length > 10) this.value = this.value.slice(0,10); this.value=this.value.replace(/[^0-9]/g,'');"
                    placeholder="Mobile Number*"
                    v-bind:class="{'profile_edit form-control':true, 'is-invalid' : !validMobile(mobile) && mobileBlured}"
                    v-on:blur="mobileBlured = true"
                    type = "tel"
                    >
                  <div class="invalid-feedback">please enter 10 digit valid mobile number</div>
                </float-label>
              </div>
              <div class="OTPForm">
                <div class="w3-center">
                  <div class="dv-btn dv-btn-addon" fxlayoutalign="center center">             
                    <button mat-raised-button="" v-on:click.prevent="signup()" class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn" ><span class="mat-button-wrapper"><b>SEND OTP</b></span>
                      <div class="mat-button-ripple mat-ripple" matripple=""></div>
                      <div class="mat-button-focus-overlay"></div>
                    </button>   
                  </div>
                </div>
              </div>
            </form>
          </div>
          <!-- login-screen-end -->

          <!-- otp-screen-start -->
          <div v-if="isSignUp">

            <h3 class="login-section"> OTP </h3>

            <form class="login-form">
              <float-label>
              <div class="form-group">
                <input 
                    id="u-otp"  
                    v-model="otp"
                    required 
                    placeholder="OTP*"
                    oninput="javascript: if (this.value.length > 4) this.value = this.value.slice(0,4); this.value=this.value.replace(/[^0-9]/g,'');"
                    v-bind:class="{'profile_edit form-control':true, 'is-invalid' : !validOTP(otp) && otpBlured}"
                    v-on:blur="otpBlured = true"
                    type = "tel"
                    >
                <div class="invalid-feedback">please enter 4 digit valid OTP</div>
              </div>
              </float-label>

            <div class="OTPForm">

              <div class="w3-center">
                <div class="login-section">
                  <h6>Don't Recieve? <a class="underlineText" v-on:click.prevent="resendotp();"> Resend OTP</a></h6>
                </div>
                <div class="dv-btn dv-btn-addon" fxlayoutalign="center center">             
                <button mat-raised-button="" v-on:click.prevent="verifyotp()" class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn" ><span class="mat-button-wrapper"><b>ENTER OTP</b></span>
                  <div class="mat-button-ripple mat-ripple" matripple=""></div>
                  <div class="mat-button-focus-overlay"></div>
                </button>   
                </div>
              </div>
            </div>
            </form>
          </div>
          <!-- otp-screen-end -->
        </div>
        <div class="col-12 col-sm-3 col-md-3"></div>
      </div>
    </div>
    <!-- login-and-otp-screen-end -->
    <div  v-if="isAddressCard" class="section addressDiv">
      <div class="container">
          <div class="loginAndOtp addressSection">
            <form>
              <div>
                <h5 class="product"> Delivery Address <a @click.prevent="editLocation()" class="underlineText edit_location">Edit Location</a> </h5>
                <p id="searchAddress" class="address-form-searchAddress">{{searchAddress}}</p>
              </div>
            <!-- address-card-row-first-start  -->
              
              <div class="form-group">
                <float-label>
                <input 
                    id="profile_name"  
                    v-model="userDetails.first_name" 
                    required 
                    placeholder="Name*"
                    v-bind:class="{'profile_edit form-control':true, 'is-invalid' : !validName(userDetails.first_name) && nameBlured}"
                    v-on:blur="nameBlured = true"
                    >
                <div class="invalid-feedback">name is required</div>
                </float-label>
              </div>
                <!--label for="exampleInputEmail1">Email <span class="required">*</span></label-->
              <div class="form-group">
                <float-label>
                <input
                    id="profile_email"
                    v-model="userDetails.email" 
                    required 
                    placeholder="Email"
                    v-bind:class="{'profile_edit form-control':true, 'is-invalid' : !validEmail(userDetails.email) && emailBlured}"
                    v-on:blur="emailBlured = true"
                    >
                <div class="invalid-feedback">please enter a valid email</div>
                </float-label>
              </div>

              <div class="form-group">
                <float-label>
                <input 
                      id="address1"
                      v-model="address1"
                      required
                      placeholder="H.No | Floor | Locality *"
                      v-bind:class="{'profile_edit location_edit form-control':true, 'is-invalid' : !validAddress1(address1) && address1Blured}"
                      v-on:blur="address1Blured = true"
                      >
                <div class="invalid-feedback">H.No | Floor | Locality is required</div>
                </float-label>
                </div>

                <!--label for="exampleInputEmail1">LANDMARK</label-->
                <float-label>
                <input class="profile_edit location_edit form-control" id="address2" v-model="address2" placeholder="Landmark">
                </float-label>
                <br>
                <!-- address-card-row-first-end -->
                <!-- address-card-row-second-start -->
                <b-row>
                  <b-col align-self="center">
                    <div class="dv-btn dv-btn-addon" fxlayoutalign="center center">             
                      <button mat-raised-button="" v-on:click.prevent="updateProfileAddress()" class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn" ><span class="mat-button-wrapper"><b>Save & Continue</b></span>
                        <div class="mat-button-ripple mat-ripple" matripple=""></div>
                        <div class="mat-button-focus-overlay"></div>
                      </button>   
                    </div>
                  </b-col>
                </b-row>
                <!-- address-card-row-second-end -->                   
            </form>
          </div>
          
        </div>
      </div>



    <div class="section" v-if="isMobCardShow===false">
      <div class="container">
      <div class="row">
        <div class="col-12 col-sm-3 col-md-3"></div>
        <div class="col-12 col-sm-6 col-md-6">
          <!-- prod-list-card-start -->
          <div v-if="isProdListCardShow">
           <div v-if="isPrepaidOnly=='no'" class="product">Choose Product Plan</div>
           <div v-else class="product">Products</div>
           <b-form-group v-if="isPrepaidOnly=='no'">
              <b-form-radio-group 
                id="btn-radios-3"
                @change = "cartUpdate()"
                v-model="subscription_type"
                :options="[{text: 'Prepaid',value: 'Prepaid'}, {text: 'Postpaid', value: 'Postpaid'}]"
                size="sm"
                name="radio-btn-outline-type"
                required
                buttons
              ></b-form-radio-group>
            </b-form-group>
            <!-- card-row-first-start -->
            <b-row>
              <!-- card-column-left-start -->
              <b-col>
               <!--div class="product">Product</div-->
                <div class="row">
                <div class="col-12 col-sm-12 col-md-12">
                  <div class="dv-products" fxflex="50" fxlayoutalign="center start" fxlayoutalign.lt-md="center center">
                        <div fxflex="100" fxlayout="column" fxlayoutalign="center center" style="flex-direction: column;">
                            <div v-if="products && products.length > 0" id="dv-products" class="dv-products pd-bot-10 pd-top-10">
                                <div v-for="product in products" :key="product['product_id']" fxlayout="row" fxlayoutalign="center center" style="margin-bottom: 10px; flex-direction: row; box-sizing: border-box; display: flex; place-content: center; align-items: center;" class="ng-star-inserted">
                                    <div fxflex="16" style="flex: 1 1 100%; box-sizing: border-box; max-width: 20%;"><img style="height:40px;width:40px;" v-bind:src="'https://doodhvale.in'+ product['product_image_url']"></div>
                                    <div class="ml-10" fxflex="50" fxlayout="column" style="flex-direction: column; box-sizing: border-box; display: flex; flex: 1 1 100%; max-width: 50%;">
                                      <div class="product-name-txt"> {{product['product_name']}} - {{product['product_price_list'][0]['quantity']}} {{product['product_price_list'][0]['unit']}} </div>
                                      <div><span class="discountedPrice" v-if="subscription_type=='Prepaid'">₹ {{product['prepaid_price']}} <!--del class="cd-color-grey fnt-wt-normal ng-star-inserted">{{product['product_price_list'][0]['mrp']}}</del--></span>
                                  <span class="discountedPrice" v-else>₹ {{product['postpaid_price']}} <!--del class="cd-color-grey fnt-wt-normal ng-star-inserted">{{product['product_price_list'][0]['mrp']}} </del--></span></div>
                                    </div>
                                    <div fxflex="34" fxlayoutalign="end" style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex; flex: 1 1 100%; max-width: 34%;">
                                        
                                    <div v-if="product['status']== 2" class="error-address">
                                      out of stock
                                    </div>
                                    <div v-else >

                                        <div v-if="product['quantity']==0 || product['quantity'] == null" class="quantity-toggle">
                                        
                                          <div class="quantity-toggle ng-star-inserted">
                                            <div @click.prevent="increment(product)" class="dv-quantity-add-box">
                                              <span>ADD</span>
                                              <i class="now-ui-icons ui-1_simple-add12"></i>
                                              <!--b-icon icon="plus"></b-icon-->
                                            </div>
                                          </div>
                                        </div>
                                        <div v-else class="quantity-toggle">
                                         <div @click.prevent="decrement(product)" class="dv-quantity-sub" fxlayoutalign="center center" style="place-content: center; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;">
                                          <i class="now-ui-icons ui-1_simple-delete"></i>
                                          <!--b-icon style="height: 20px;width: 20px;" icon="dash"></b-icon-->
                                         </div>
                                         <div class="dv-quantity" fxlayoutalign="center center" style="place-content: center; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;"> 
                                          <input type="text" :value="product['quantity']" readonly>
                                         </div>
                                         <div @click.prevent="increment(product)" class="dv-quantity-add" fxlayoutalign="center center" style="place-content: center; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;">
                                          <i class="now-ui-icons ui-1_simple-add"></i>
                                          <!--b-icon style="height: 20px;width: 20px;" icon="plus"></b-icon-->
                                         </div>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                            <div class="product" id="show-more-prod" v-on:click.prevent="showMoreProducts()" fxlayoutalign="center center" style="place-content: center; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;"><span>View More Products</span></div>
                            <div class="product">Delivery Start Date</div>
                            <div class="topMargin leftMargin" style="text-align: center;">
                                <b-form-group>
                                  <b-form-radio-group 
                                    id="btn-radios-2"
                                    v-model="start_date"
                                    :options="options"
                                    size="sm"
                                    name="radio-btn-outline"
                                    required
                                    buttons
                                  ></b-form-radio-group>
                                </b-form-group>
                                
                              <div class="dv-total"><span>Order Total &nbsp;</span><span>₹ {{total_price_after_discount}}&nbsp;</span>
                                <!--del class="cd-color-grey fnt-wt-normal ng-star-inserted">₹ {{total_price_before_discount}}</del-->&nbsp; <!--<span>({{trial}}% off for {{days}} Days)</span>-->
                              </div>
                              <!--hr>
                                  <div class="product">Ring the bell or Not?</div>
                                  <div style="width: 49.35%; float: left;">
                                    <div v-if="ringOnNotSelected === true" v-on:click.prevent="bellStatusChange($event)" id="ring_on_not_selected" style="float: right;">
                                    <img v-on:click.prevent="bellStatusChange($event)" id="ring_on_not_selected" src="img/ring_on_not_selected.png" style="width:37%;">
                                    </div>
                                    <div v-if="ringOnSelected === true" v-on:click.prevent="bellStatusChange($event)" id="ring_on_selected" style="float: right;">
                                    <img v-on:click.prevent="bellStatusChange($event)" id="ring_on_selected" src="img/ring_on_selected.png" style="width:37%;">
                                    </div>
                                  </div>

                                  <div style="width: .30%; float: left; background: gray; height: 40px;"></div>
                                  
                                  <div style="width: 49.35%; float: right;">
                                    <div v-if="ringOffNotSelected === true" v-on:click.prevent="bellStatusChange($event)" id="ring_off_not_selected" style="float: left;">
                                    <img  v-on:click.prevent="bellStatusChange($event)" id="ring_off_not_selected" src="img/ring_off_not_selected.png" style="width:37%;">
                                    </div>
                                    <div v-if="ringOffSelected === true" v-on:click.prevent="bellStatusChange($event)" id="ring_off_selected" style="float: left;">
                                    <img v-on:click.prevent="bellStatusChange($event)" id="ring_off_selected" src="img/ring_off_selected.png" style="width:37%;">
                                    </div>
                                  </div-->
                                <div class="bottomMargin" style="clear: both;"></div>
                            </div>
                        </div>
                      </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <!-- card-row-first-end -->
            <!-- card-row-second-start -->
            <b-row><!--v-if="isMobileVerified"-->
              <b-col align-self="center">
                <div class="dv-btn dv-btn-addon" fxlayoutalign="center center">             
                  <button mat-raised-button="" v-on:click.prevent="showMobileCardorFinalCart()" class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn"  value="" :disabled="(!(total_product_quantity > 0) || /*!isMobileVerified ||*/ !start_date)" ><span class="mat-button-wrapper">PROCEED</span>
                    <div class="mat-button-ripple mat-ripple" matripple=""></div>
                    <div class="mat-button-focus-overlay"></div>
                  </button>
                </div>
              </b-col>
            </b-row>
            <!-- card-row-second-end -->
          </div>
          <!-- prod-list-card-end -->

          <!-- address-card-start -->
               
          <!-- address-card-end -->
          
         <!-- informational-card-start -->
          <div class="information-card" v-if="isInformationalCard">
            <b-row>
            <b-col align-self="center">
              <div v-for="product in updatedProdList" :key="product['product_id']" >
                <b-list-group class="product">
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      {{product.product_name}} -> {{product.msg}}
                      <b-icon v-if="product.msg === 'You have subscribed successfully.' || product.msg === 'Success'" icon="check-box" scale="1" variant="Success"></b-icon>
                      <b-icon v-if="product.msg != 'You have subscribed successfully.' && product.msg != 'Success' " icon="x-circle" scale="1" variant="danger"></b-icon>
                    </b-list-group-item>
                </b-list-group>
              </div>
                  <button mat-raised-button="" v-on:click.prevent="goback()" class="mat-raised-button ng-star-inserted btn btn-info btn-lg btn-block dv-primary-btn"  ><span class="mat-button-wrapper">OK</span>
                    <div class="mat-button-ripple mat-ripple" matripple=""></div>
                    <div class="mat-button-focus-overlay"></div>
                  </button>
              </b-col>
            </b-row>
          </div>
          <!-- informational-card-end -->

         <!-- payment-card-start -->
          <div v-if="isPaymentCard">
            <!-- <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading> -->
            <div id="bafore_checksum" style="display:none;">
              <div v-if="userData">
                <!-- <div id="url_expired">
                      <h3>Something Went Wrong, Try Again!<a style="text-decoration:underline;" v-on:click="goback();"><b>Go Back</b></a></h3>
                </div> -->
                <div id="url_valid">
                  <div style="text-align:center;">
                    <!-- <div><h4>Welcome {{custName}}<br>({{mobile}})</h4></div> -->
                    <p class="product wallet-header">Wallet</p>
                    <div class="wallet product">
                    <!-- <div id="clear">
                      <h4 style="color: #fff;">No Dues</h4>
                      <div class="pending_wallet"><i class="fa fa-rupee-sign" style="color: #fff;"></i><b style="color: #fff;">{{apiDataObj.wallet_amount}}</b></div>
                    </div>
                    <div id="pending">
                      <h4 style="color: #fff;">Pending Amount</h4>
                      <div class="pending_wallet"><i class="fa fa-rupee-sign" style="color: #fff;"></i><b style="color: #fff;">{{apiDataObj.pending_amount}}</b></div>
                    </div> -->
                    <div id="not_pending">
                      <h4 class="available-balance-header">Available Balance</h4>
                      <div class="pending_wallet"><i class="fa fa-rupee-sign" style="color: #fff;"></i><b style="color: #fff;">&nbsp;&nbsp;&nbsp;{{apiDataObj.wallet_amount}}</b></div>
                    </div>
                    </div>
                    <br>
                    <p class="product select-amount-para">Select An Amount</p>
                    <div >
                      <div v-if="isQuickPaymentButtonDisplay === 1">
                        <input class="quickPaymentButton" v-model="btnOneValue" type="button" v-on:click.prevent="btnOneClick">
                        <input id='quickPaymentButtonTwo'  class="quickPaymentButton" v-model="btnTwoValue" type="button" v-on:click.prevent="btnTwoClick">
                        <input id='quickPaymentButtonThree' class="quickPaymentButton" v-model="btnThreeValue" type="button" v-on:click.prevent="btnThreeClick">
                        <input id='quickPaymentButtonFour'  class="quickPaymentButton" v-model="btnFourValue" type="button" v-on:click.prevent="btnFourClick">
                      </div>
                      <form>
                        <!-- <i class="fa fa-rupee-sign"></i> -->
                        <!-- <input id="txn_amt" class="amount_text" name="TXN_AMOUNT" v-model="apiDataObj.default_amount" type="tel" oninput="this.value=this.value.replace(/[^0-9]/g,'');" placeholder="Amount" autofocus><br><br> -->
                        <p style="text-align: left;" class="product">Enter Custom Amount</p>
                        <div class="form-group">
                          <b-form-group
                            id="fieldset-1"
                            class="custom-amount-input"
                            label for="Enter Custom Amount"
                          ><b-form-input id="txn_amt" class="amount_text" name="TXN_AMOUNT" type="number" v-model="apiDataObj.default_amount" :min="apiDataObj.default_amount" oninput="this.value=this.value.replace(/[^0-9]/g,'');"  placeholder="Enter Amount" ></b-form-input>
                          </b-form-group>
                        </div>
                        <!-- <b-notification type="is-danger" :closable="false" :active.sync="isActive">
                            {{this.errors}}
                        </b-notification> -->
                        <!-- <div v-else> -->
                          <!-- <input class="quickPaymentButton" v-model="fiveDeliveryAmountLabel" type="button" v-on:click.prevent="fiveDeliveryBtnClick"> -->
                          <!-- <input class="quickPaymentButton" v-model="sevenDeliveryAmountLabel" type="button" v-on:click.prevent="sevenDeliveryBtnClick">
                          <input style="margin-left: 10px;" class="quickPaymentButton" v-model="fifteenDeliveryAmountLabel" type="button" v-on:click.prevent="fifteenDeliveryBtnClick">
                          <input style="margin-left: 10px;" class="quickPaymentButton" v-model="thirtyDeliveryAmountLabel" type="button" v-on:click.prevent="thirtyDeliveryBtnClick"><br>
                          <input class="quickPaymentButton" v-model="fourtyFiveDeliveryAmountLabel" type="button" v-on:click.prevent="fourtyFiveDeliveryBtnClick">
                          <input style="margin-left: 10px;" class="quickPaymentButton" v-model="sixtyDeliveryAmountLabel" type="button" v-on:click.prevent="sixtyDeliveryBtnClick"> -->
                          <!-- <input style="margin-left: 10px;" class="quickPaymentButton" v-model="ninetyDeliveryAmountLabel" type="button" v-on:click.prevent="ninetyDeliveryBtnClick"> -->
                        <!-- </div> -->
                        <b-button style= "margin-top: -23px" size="lg" v-on:click.prevent="generateChecksum" variant="primary" class="btn-block dv-primary-btn">
                        Process To Pay <b-icon icon="credit-card" aria-hidden="true" ></b-icon>
                        </b-button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="after_checksum" style="display:none !important;">
                <div class="after_checksum">
                  <br/>
                  Dear {{userDetails.first_name}}
                  <br/>
                  {{userDetails.address}}
                  <br/><br/>
                  Amount<i class="fa fa-rupee-sign"></i><b>{{genChecksum.TXN_AMOUNT}}</b><br><br>
                  <div>
                    <form method="post" name="paytmFormSubmit" id="paytmFormSubmit" action="https://securegw.paytm.in/theia/processTransaction"> 
                    <!-- <form method="post" name="paytmFormSubmit" id="paytmFormSubmit" action="https://pguat.paytm.com/oltp-web/processTransaction"--><!-- staging -->
                      <input type="hidden" name="MID" v-model="genChecksum.MID">
                      <input type="hidden" name="ORDER_ID" v-model="genChecksum.ORDER_ID">
                      <input type="hidden" name="CUST_ID" v-model="genChecksum.CUST_ID">
                      <input type="hidden" name="INDUSTRY_TYPE_ID" v-model="genChecksum.INDUSTRY_TYPE_ID">
                      <input type="hidden" name="CHANNEL_ID" v-model="genChecksum.CHANNEL_ID">
                      <input type="hidden" name="WEBSITE" v-model="genChecksum.WEBSITE">
                      <input type="hidden" name="CALLBACK_URL" v-model="genChecksum.CALLBACK_URL">
                      <input type="hidden" name="CHECKSUMHASH" v-model="genChecksum.checksum">
                      <input type="hidden" name="TXN_AMOUNT" v-model="genChecksum.TXN_AMOUNT">
                      <input type="hidden" name="MERC_UNQ_REF" v-model="genChecksum.MERC_UNQ_REF">
                      <input id="pay" class="button5 btn btn-block dv-primary-btn" value="Continue" type="submit"  v-on:click.prevent="isLoading=true">
                    </form>
                  </div>
                </div>
              </div>
              <div v-if="app_payment_gate" style="display:none !important;">
                <div>
                  <br/>
                  Dear {{userDetails.first_name}}
                  <br/>
                   {{userDetails.address}}
                  <br/>
                  <br/>
                  Amount<span>&nbsp;<i class="fa fa-rupee-sign"></i><b>&nbsp;{{appPaymentGateway.TXN_AMOUNT}}</b></span><br><br>
                  <div>
                    <!-- <form method="post" v-on:{{appPaymentGateway.actionUrl}}> -->
                    <form method="post" :action="formRequest" name="hdfcFormSubmit" id="hdfcFormSubmit">
                    <!-- <form method="post" action="https://doodhvale.in/dv/doodhvale/api/modules/v3/controllers/ccavRequestHandler.php"> -->
                    <!-- <form method="post" action="https://pguat.paytm.com/oltp-web/processTransaction"> --><!-- staging -->
                      <input type="hidden" name="tid" v-model="appPaymentGateway.TID"/>
                      <!-- for test key-->
                      <!--<input type="hidden" name="merchant_id" value="208602"/>-->
                      <!-- for prod key-->
                      <input type="hidden" name="merchant_id" value="242357"/>
                      <input type="hidden" name="order_id" v-model="appPaymentGateway.ORDER_ID"/>
                      <input type="hidden" name="amount" v-model="appPaymentGateway.TXN_AMOUNT"/>
                      <input type="hidden" name="currency" value="INR"/>
                      <input type="hidden" name="redirect_url" v-model="appPaymentGateway.responseUrl"/>
                      <input type="hidden" name="cancel_url" v-model="appPaymentGateway.responseUrl"/>
                      <input type="hidden" name="language" value="EN"/>
                      <input type="hidden" name="delivery_name" v-model="userDetails.fullName"/>
                      <input type="hidden" name="delivery_address" v-model="userDetails.address"/>
                      <input type="hidden" name="delivery_city" v-model="userDetails.city"/>
                      <input type="hidden" name="delivery_state" v-model="userDetails.state"/>
                      <input type="hidden" name="delivery_zip" v-model="pincode"/>
                      <input type="hidden" name="delivery_country" value="India"/>
                      <input type="hidden" name="delivery_tel" v-model="mobile"/>
                      <input type="hidden" name="merchant_param1" v-model="apiDataObj.userId"/>
                      <input type="hidden" name="merchant_param2" v-model="appPaymentGateway.CALLBACK_URL"/>
                      <input type="hidden" name="merchant_param3" v-model="appPaymentGateway.APP_PAYMENT_GATEWAY"/>
                      <input type="hidden" name="merchant_param4" v-model="appPaymentGateway.apiUrl"/>
                      <input id="hdfc-pay" class="button5 btn btn-block dv-primary-btn" value="Continue"  type="submit"   v-on:click.prevent="isLoading=true"/>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- payment-card-end -->

        </div>
        <div class="col-12 col-sm-3 col-md-3"></div>
      </div>

      <!-- final-calculated-card-start -->
        <div v-if="isFinalCart">
          <div class="row finalcart">
            <div class="col-12 col-sm-3 col-md-3"></div>
            <div class="col-12 col-sm-6 col-md-6">
            <div>
            <div class="product">Delivery Address <a @click.prevent="editLocation()" style="margin-right:2px;" class="underlineText cart-table edit_location">Edit</a></div>
              <p >{{custAddress}}</p>
            </div>
              <table border="0" cellpadding="0" cellspacing="0" class="cart-table">
                <tbody>
                  <tr class="cart-table-header-row">
                    <th class="product">Order Summary</th>
                    <th></th>
                    <th></th>
                    <th style="padding: 1px;"><a @click.prevent="backToProdList()" class="underlineText edit_location">Edit</a></th>
                  </tr>
                  <tr class="active">
                    <!-- <th>#</th> -->
                    <th style="width: 70%;">Product Name</th>
                    <th style="width: 10%; text-align:center;" >Mrp</th>
                    <th style="width: 10%; text-align:center;" >Qty</th>
                    <th style="width: 10%; text-align:center;" >Amt</th>
                  </tr>            
                  <tr class="cart-table-content-row" v-for="(product) in cart" v-bind:key="product.id">
                      <td style="width: 70%;" >{{product.product_name}}  ({{product.product_quantity}} {{product.product_unit}})</td>
                      <td style="width: 10%; text-align:center;" >₹{{product.product_price}}.00</td>
                      <td style="width: 10%; text-align:center;" >{{product.quantity}}</td>
                      <td style="width: 10%; text-align:center;" >₹{{product.product_price * product.quantity}}.00</td>
                  </tr>
                  <!-- <tr><th></th><th></th><th></th></tr> -->
                  <tr class="cart-table-footer-row">
                    <td style="width: 70%;"><b>Order Total</b></td>
                    <td style="width: 10%; text-align:center;" ></td>
                    <td style="width: 10%; text-align:center;" ></td>
                    <td style="width: 10%; text-align:center"><b>₹{{total_price_after_discount.toFixed(2)}}</b></td>
                  </tr>
                </tbody>
              </table>
              <div class="row">
                <div class="col-5 col-sm-6 col-md-6">
                  <div class="product payment-mode">Payment Mode</div>
                </div>
                <div class="col-5 col-sm-6 col-md-6 mod-bal-float-right">
                  <div class="product sub-type" id='subscription-type'>{{this.subscription_type}}</div>
                </div>
              </div>
              <div class="row" v-if="subscription_type == 'Prepaid' ">
                <div class="col-5 col-sm-6 col-md-6">
                  <div class="product">Wallet Balance</div>
                </div>
                <div class="col-5 col-sm-6 col-md-6 mod-bal-float-right">
                  <div class="product" id='subscription-type'>₹ {{walletBal}}.00 </div>
                </div>
              </div>
              <div class="row" v-if="subscription_type == 'Prepaid' && rechargeAmt > 0">
                <div class="col-12 col-sm-6 col-md-6">
                <div class="wallet-msg">
                  <p>{{this.msg}}</p>
                </div>
                <b-form-group class="payment-mode">
                 <b-form-radio class="payment-mode-options" v-model="payment_type" name="some-radios" value="2">Credit or Debit Card/Net Banking</b-form-radio>
                 <b-form-radio class="payment-mode-options" v-model="payment_type" name="some-radios" value="1">Paytm Wallet / UPI</b-form-radio>
                </b-form-group>
                </div>
              </div> 

               <!--div style="margin-left: 1em; padding-top: 24px; padding-bottom: 30px;">
                <p style="font-size: 12px; float:left; "><b>Payment Mode</b></p>
                <p style="font-size: 12px; float:right;"><b>{{this.subscription_type}}</b></p>
              </div--> 
              <b-row v-if="subscription_type == 'Prepaid' && rechargeAmt > 0">
              <!-- <b-button v-on:click.prevent="backToProdList()">
                <b-icon icon="arrow-left"></b-icon>
              </b-button> -->
                <b-col align-self="center">
                  <!-- <div class="ncd-trial-btn pd-top-10" fxlayoutalign="center center" style="place-content: center; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;">
                    <button mat-raised-button="" v-on:click.prevent="verifySubscription()" class="mat-raised-button ng-star-inserted btn btn-info btn-lg place-order-btn OTP-button"  value="" :disabled="(!(total_product_quantity > 0) || /*!isMobileVerified ||*/ !start_date)" ><span class="mat-button-wrapper"><b>Place Order</b></span>
                      <div class="mat-button-ripple mat-ripple" matripple=""></div>
                      <div class="mat-button-focus-overlay"></div>
                    </button>
                  </div> -->
                  <div class="dv-btn dv-btn-addon" fxlayoutalign="center center">             
                    <button mat-raised-button="" v-on:click.prevent="generateChecksum()" class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn" ><span class="mat-button-wrapper">Add ₹ {{this.rechargeAmt}} & Continue</span>
                      <div class="mat-button-ripple mat-ripple" matripple=""></div>
                      <div class="mat-button-focus-overlay"></div>
                    </button>
                  </div>
                </b-col>
              </b-row>
              <b-row v-else>
              <!-- <b-button v-on:click.prevent="backToProdList()">
                <b-icon icon="arrow-left"></b-icon>
              </b-button> -->
                <b-col align-self="center">
                  <!-- <div class="ncd-trial-btn pd-top-10" fxlayoutalign="center center" style="place-content: center; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;">
                    <button mat-raised-button="" v-on:click.prevent="submitCart()" class="mat-raised-button ng-star-inserted btn btn-info btn-lg place-order-btn"  value="" :disabled="(!(total_product_quantity > 0) || /*!isMobileVerified ||*/ !start_date)" ><span class="mat-button-wrapper"><b>Place Order</b></span>
                      <div class="mat-button-ripple mat-ripple" matripple=""></div>
                      <div class="mat-button-focus-overlay"></div>
                    </button>
                  </div> -->
                  <div class="dv-btn dv-btn-addon" fxlayoutalign="center center">             
                    <button mat-raised-button="" v-on:click.prevent="submitCart()" class="mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn" ><span class="mat-button-wrapper">Place Order</span>
                      <div class="mat-button-ripple mat-ripple" matripple=""></div>
                      <div class="mat-button-focus-overlay"></div>
                    </button>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <!-- final-calculated-card-end -->

    </div>
    </div>
  </div>
</template>

<script>
import { Card, Tabs, TabPane, Button, FormGroupInput } from '@/components';
import axios from 'axios';
import { gmapApi } from "vue2-google-maps";
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: 'profile',
  bodyClass: 'profile-page',
  components: {
    Tabs,
    TabPane,
    Card,
    [FormGroupInput.name]: FormGroupInput,
    Loading
  },
  computed: {
    google: gmapApi,
    mobstate() {
      if (isNaN(this.mobile) || this.mobile.length !== 10 || this.mobile === '')
      {
        return false
      }else{
        return true
      }

        //return this.mobile.length == 10 ? true : false
      },
      validFeedback() {
        return this.mobstate === true ? '' : ''
      },
      otpstate() {
      if (isNaN(this.otp) || this.otp.length !== 4 || this.otp === '')
      {
        return false
      }else{
        return true
      }
      },
  },
  data() {
    return {
      apiUrl: 'https://doodhvale.in/dv/',
      //apiUrl: 'http://localhost:8888/doodhvale-admin/',
      formRequest: 'https://doodhvale.in/dv/doodhvale/api/modules/v3/controllers/ccavRequestHandler.php',
      //vueUrl: 'http://localhost:8081/#/trialOffer',
      vueUrl: 'https://www.doodhvale.com/app/#/trialOffer',
      //loginBackgroundImg: 'img/Layer7.png',
      //orangeBackground: 'img/layer9.png',
      center: { lat: 28.664081, lng: 77.389001 },
      markers: [
        {
          position: { lat: 28.664081, lng: 77.389001 }
        }
      ],
      isPaymentCard: false,
      reqWallAmt: 0,
      rechargeAmt: 0,
      showmap: false,
      otp: '',
      mobile: '',
      isPrepaidOnly: 'no',
      pincode: '000000',
      city: 'North Delhi',
      country: '',
      state: '',
      locality: '',
      formattedAddress: '',
      profileSet: [],
      userDetails: [],
      cityList: [],
      gender: 'M',
      profile: false,
      isInformationalCard: false,
      updatedProdList: [],
      address1: '',
      address2: '',
      total_price_before_discount: 0,
      total_price_after_discount: 0,
      tomorrow: new Date,
      tomorrowplus1: new Date,
      tomorrowplus2: new Date,
      products: [],
      quantity: 0,
      selected: 'first',
      start_date: false,
      options: [],
      days: 0,
      isMobileVerified: false,
      isAddressCard: false,
      isSignUp: false,
      isProdListCardShow: true,
      isMobCardShow: false,
      cart: [],
      list: [],
      isFinalCart: false,
      userId: 451,
      total_product_quantity: 0,
      ringOnNotSelected: false,
      ringOnSelected: true,
      ringOffNotSelected: true,
      ringOffSelected: false,
      subscription_type: 'Prepaid',
      is_profile: 0,
      // pp.vue data() start
      payment_url: '',
      urlInterface: [],
      apiDataObj: [],
      genChecksum: [],
      appPaymentGateway: [],
      after_checksum: false,
      userData: true,
      app_payment_gate: false,
      payment_type: '2',
      errors: '',
      isActive: false,
      isLoading: true,
      isLoaded: false,
      isFullPage: true,
      btnOneValue: 100,
      btnTwoValue: 200,
      btnThreeValue: 500,
      btnFourValue: 1000,
      isQuickPaymentButtonDisplay: 1,
      fiveDeliveryAmount: 100,
      sevenDeliveryAmount: 200,
      fifteenDeliveryAmount: 400,
      thirtyDeliveryAmount: 800,
      fourtyFiveDeliveryAmount: 1200,
      sixtyDeliveryAmount: 1600,
      ninetyDeliveryAmount: 2400,
      custName: '',
      custAddress: '',
      fiveDeliveryAmountLabel: '5 Deliveries',
      sevenDeliveryAmountLabel: '7 Deliveries',
      fifteenDeliveryAmountLabel: '15 Deliveries',
      thirtyDeliveryAmountLabel: '30 Deliveries',
      fourtyFiveDeliveryAmountLabel: '45 Deliveries',
      sixtyDeliveryAmountLabel: '60 Deliveries',
      ninetyDeliveryAmountLabel: '90 Deliveries',
      emailBlured : false,
      nameBlured : false,
      mobileBlured: false,
      otpBlured: false,
      searchAddressBlured: false,
      address1Blured: false,
      searchAddress:'',
      msg:'',
      walletBal: 0
      //pp.vue data() end 
    }
  },
  created() {
     var bottomMenu = document.getElementById('bottomMenu');
    if(bottomMenu){
      bottomMenu.classList.add('hidebottomMenu');
      document.getElementById('sm_bottom_menu').style.top = '-80px'
      //document.getElementById('sm_bottom_menu').style.bottom = '0'
    } 
    this.getProductList()
    //this.userLocation()  
  },
  methods: {

     validate : function(){
      this.nameBlured = true
      this.address1Blured = true
       if(this.validAddress1(this.address1) 
          && this.validEmail(this.userDetails.email)
          && this.validName(this.userDetails.first_name)){
          return true;
       } else {
         return false;
       }
    },

    validMobileForm : function(){

      this.mobileBlured = true
      
      if(this.validMobile(this.mobile)){
          return true;
       } else {
         return false;
       }

    },

    validOTPForm : function(){

      this.otpBlured = true
      
      if(this.validOTP(this.otp)){
          return true;
       } else {
         return false;
       }

    },


    validEmail : function(email) {
      if (typeof email == 'undefined'){
        email = ''
      }
      if(email== ''){
        return true
      }
        var re = /(.+)@(.+){2,}\.(.+){2,}/;
        return re.test(email.toLowerCase());
    },

    validMobile : function(mobile) {
      // debugger
      if (typeof mobile == 'undefined'){
        mobile = ''
      }
      mobile = mobile.slice(0,10);
      if (isNaN(mobile) || mobile.length !== 10 || mobile === '') {
        return false
      }
        return true
    },

    validOTP : function(otp) {
      // debugger
      if (typeof otp == 'undefined'){
        otp = ''
      }
      otp = otp.slice(0,4);
      if (isNaN(this.otp) || this.otp.length < 4 || this.otp === '') {
        return false
      } 
        return true
    },
    
    validName: function(name) {
      if (typeof name == 'undefined'){
        name = ''
      }
      if(name == ''){
        return false
      } else {
        return true
      }
    },

    validAddress1: function(address1) {
      if (typeof address1 == 'undefined'){
        address1 = ''
      }
      if(address1 == ''){
        return false
      } else {
        return true
      }
    },

		scrollToTop() { 
			window.scrollTo(0, 0); 
    },
    
    showMoreProducts(){
      document.getElementById('dv-products').style.overflow = 'auto'
      document.getElementById('show-more-prod').style.display = 'none'
    },
    editLocation(){
      if(this.isFinalCart===true){
        this.isFinalCart = false
        this.isAddressCard = true
        return
      }
      this.$bvModal.show('bv-modal-address')
      if (document.getElementById('userAddress')) {
        document.getElementById('userAddress').value = document.getElementById('searchAddress').innerHTML
      }
      setTimeout(function() {document.getElementById('madal-error-address').style.display = 'none'}, 4000)

    },
    
    cartUpdate(){
      this.getProductList()
      this.total_price_after_discount = 0
      this.total_price_before_discount = 0
      
    },

    address (lats, lngs) {
      //debugger
        let latlng = {lat: lats, lng: lngs}
        const google = window.google
        // alert(google)
        if (google !== undefined) {
          var geocoder = new google.maps.Geocoder()
          var myScope = this
          geocoder.geocode({'location': latlng}, function (results, status) {
            if (status === 'OK') {
              if (results[0]) {
                myScope.fillAddress(results)
              } else {
                window.alert('No location found')
              }
            } else {
              //window.alert('Geocoder failed due to: ' + status);
            }
          })
        } else {
          //debugger
           axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + lats + "," + lngs + "&key=AIzaSyArGgueGCb2p4sqjU4pScADLskS9OxZ8jQ")
        .then((response) => {
            // Ideally you'd search for the index with type = sublocality in address_components
            this.fillAddress(response.data.results)
          })  
        }
      },
    fillAddress(address){
      if (document.getElementById('del_loc')) {
                  document.getElementById('del_loc').value = address[0].formatted_address
                  //document.getElementById('searchAddress').value = address[0].formatted_address
                }
                // debugger
                var myAddress = document.getElementById('searchAddress');
                if(myAddress){
                    // this.searchAddress = address[0].formatted_address
                    myAddress.innerHTML = address[0].formatted_address
                    document.getElementById('hfullAddress').value = address[0].formatted_address
                }
                this.formattedAddress = address[0].formatted_address
                let full_address = address[0].address_components
                 let sublocality_level_1 = '';
                let sublocality_level_2 = '';
                let sublocality_level_3 = '';
                for (var i = 0; i < full_address.length; i++) {
                    if (full_address[i].types.includes("sublocality_level_1")){ sublocality_level_1 = full_address[i].long_name; }    
                    if (full_address[i].types.includes("sublocality_level_2")){ sublocality_level_2 = full_address[i].long_name; }
                    if (full_address[i].types.includes("sublocality_level_3")){ sublocality_level_3 = full_address[i].long_name; }    
                    if (full_address[i].types.includes("locality")){ this.locality = full_address[i].long_name; }
                    if (full_address[i].types.includes("administrative_area_level_2")){ this.city = full_address[i].long_name; }    
                    if (full_address[i].types.includes("administrative_area_level_1")){ this.state = full_address[i].long_name; }
                    if (full_address[i].types.includes("country")){ this.country = full_address[i].long_name; }
                    if (full_address[i].types.includes("postal_code")){ this.pincode = full_address[i].long_name; }    
                    
                }
               
                /* let length = full_address[0].address_components.length
                length = length - 1
                this.pincode = full_address[0].address_components[length].long_name
                length = length - 1
                this.country = full_address[0].address_components[length].long_name
                length = length - 1
                this.state = full_address[0].address_components[length].long_name
                length = length - 1
                this.locality = full_address[0].address_components[length].long_name
                length = length - 1
                this.city = full_address[0].address_components[length].long_name
                this.formattedAddress = full_address[0].formatted_address
                let sublocality_level_1 = full_address[0].address_components[4].long_name
                let sublocality_level_2 = full_address[0].address_components[3].long_name
                let sublocality_level_3 = full_address[0].address_components[2].long_name */
                let smallAddress = ''
                if(sublocality_level_3){
                    smallAddress = sublocality_level_3
                }else if (sublocality_level_2) {
                  smallAddress = sublocality_level_2
                }else if(sublocality_level_1) {
                  smallAddress = sublocality_level_1
                }else if(this.locality) {
                  smallAddress = this.locality
                }else{
                  smallAddress = ''
                }
                smallAddress = smallAddress + ', ' + this.pincode
                var smAdd = document.getElementById('smallAddress');
                var text_to_change = smAdd.childNodes[0];
                text_to_change.nodeValue = smallAddress;
    },
    increment(product){
      
      if(product['quantity'] == null){
        product['quantity'] = 0;
      }
      var product_price
      if (this.subscription_type=='Prepaid'){
        product_price = product['prepaid_price']
      } else {
        product_price = product['postpaid_price']
      }
      product['last_quantity'] = product['quantity']
      if( 0 <= product['quantity'] && product['quantity'] < 6){
      product['quantity']++
      this.total_product_quantity++
      this.total_price_before_discount += product_price*this.days
      this.total_price_after_discount = this.total_price_before_discount //- (this.total_price_before_discount)).toFixed(2)
      }
    },

    decrement(product){
      if(product['quantity'] == null){
        product['quantity'] = 0;
      }
        var product_price
        if (this.subscription_type=='Prepaid'){
          product_price = product['prepaid_price']
        } else {
          product_price = product['postpaid_price']
        }
       if( 1 <= product['quantity'] && product['quantity'] <= 6 ){
        product['quantity']--
        this.total_product_quantity--
        this.total_price_before_discount -= product_price*this.days
        this.total_price_after_discount = this.total_price_before_discount //- (this.total_price_before_discount)).toFixed(2)
       }
    },

    convertDate (dateString) {
      var mydate = new Date(dateString).toDateString().split(' ')
      return mydate[2] + ' ' + mydate[1] + ' ' + mydate[3]
    },

    showMobileCardorFinalCart(){
      if(this.isMobileVerified === false){
        this.isMobCardShow = true
        this.isProdListCardShow = false
      } else {  
        this.finalCart()
        if (this.subscription_type=='Prepaid'){
          this.verifySubscription()
        }
        this.isFinalCart = true
        this.isProdListCardShow = false
      }
      this.scrollToTop()
    },
    goback(){
      sessionStorage.clear()
      this.$router.go()
    },

    backToProdList()
    {
      this.isFinalCart = false
      this.isProdListCardShow = true
      this.scrollToTop()
    },

    bellStatusChange (event) {
        this.ringOnNotSelected = false
        this.ringOnSelected = false
        this.ringOffNotSelected = false
        this.ringOffSelected = false
        let bellId = event.toElement.id
        // console.log(event)
        if (bellId === 'ring_on_not_selected') {
          this.ringOnNotSelected = false
          this.ringOnSelected = true
          this.ringOffNotSelected = true
          this.ringOffSelected = false
        } else if (bellId === 'ring_on_selected') {
          this.ringOnNotSelected = false
          this.ringOnSelected = true
          this.ringOffNotSelected = true
          this.ringOffSelected = false
        } else if (bellId === 'ring_on_not_selected') {
          this.ringOnNotSelected = true
          this.ringOnSelected = false
          this.ringOffNotSelected = false
          this.ringOffSelected = true
        } else {
          this.ringOnNotSelected = true
          this.ringOnSelected = false
          this.ringOffNotSelected = false
          this.ringOffSelected = true
        }
      },

    getProductList() {
        var session  = sessionStorage.getItem('paymentFlow')
        if(sessionStorage.getItem('paymentFlow') === 'trialoffer') {
          this.userId = sessionStorage.getItem('userId')
          this.cart = sessionStorage.getItem('cart')
          this.cart = JSON.parse(this.cart)
          this.ringOnSelected = sessionStorage.getItem('ringOnSelected')
          this.start_date = sessionStorage.getItem('start_date')
          this.reqWallAmt = sessionStorage.getItem('required_wallet_amount')
          this.isProdListCardShow = false
          sessionStorage.clear()
          //debugger
          const params = new URLSearchParams()
          params.append('user_id', this.userId)
          axios({
            url: this.apiUrl + 'doodhvale/api/web/v3/accounts/account-view',
            method: 'post',
            data: params,
            withCredentials: false,
            headers: {
            }
          })
            .then(response => {
              this.isLoading =  false
              if (response.data.status === '000000') {
                  if(response.data.display_title === 'Wallet Balance'){
                    if((response.data.pending_amount * -1) >= this.reqWallAmt){
                      this.submitCart()
                    } else {
                      this.$swal({
                          customClass: {
                          popup: 'custom-swal-popup',
                          confirmButton:'mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn'
                          },
                          text: 'Your product is not subscribe beacuse you have insufficient wallet balance to subscribe',
                          allowOutsideClick: false
                        }).then((result) => {
                          if (result.value) {
                            this.$router.go()
                            } else {
                            }
                          })
                      }
                    } else {
                      this.$swal({
                        customClass: {
                        popup: 'custom-swal-popup',
                        confirmButton:'mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn'
                        },
                        text: 'Your product is not subscribe beacuse you have insufficient wallet balance to subscribe',
                        allowOutsideClick: false
                      }).then((result) => {
                        if (result.value) {
                          this.$router.go()
                          } else {
                          }
                        })
                    }
                /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
                } */
              } else{
                this.$swal({
                    customClass: {
                    popup: 'custom-swal-popup',
                    confirmButton:'mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn'
                    },
                    text: 'Something went wrong, Try Again!',
                    allowOutsideClick: false
                }).then((result) => {
                  if (result.value) {
                    this.$router.go()
                    } else {
                    }
                  })
              }
            })
            .catch(e => {
              //alert('not ok')
            })
        } else {
        let params = new URLSearchParams();
        params.append('user_id', this.userId );
        params.append('cat_id', 2 );
        this.tomorrow = new Date
        this.tomorrowplus1 =  new Date
        this.tomorrowplus2 = new Date
        axios.post(this.apiUrl + 'doodhvale/api/web/v3/products/products-with-pre-post-price', params)
        .then(response => {
          // JSON responses are automatically parsed.
          this.products = response.data.product_list
          this.isPrepaidOnly = response.data.prepaid_feature_only
          this.tomorrow.setDate(this.tomorrow.getDate() + 1)
          this.tomorrowplus1.setDate(this.tomorrow.getDate() + 1)
          this.tomorrowplus2.setDate(this.tomorrowplus1.getDate() + 1)
          this.days = 1
          this.options = [{ text: 'Tommorow', value: this.tomorrow.toISOString().slice(0,10) },
            { text: this.convertDate(this.tomorrowplus1.toISOString().slice(0,10)), value: this.tomorrowplus1.toISOString().slice(0,10)},
            {  text: this.convertDate(this.tomorrowplus2.toISOString().slice(0,10)), value: this.tomorrowplus2.toISOString().slice(0,10) }]
            this.start_date = this.tomorrow.toISOString().slice(0,10)

         this.isLoading = false

        })
        .catch(e => {
        })
      }
    },
    signup () {
      
      const params = new URLSearchParams()
      var mobile = this.mobile
      var deviceID = this.mobile
      // debugger
      if(!this.validMobileForm()){
        return
      } else {
        // this.isLoading = true
        params.append('mobile', mobile)
        params.append('app_type', "web")
        //this.isSignUp = true
        //params.append('deviceId', deviceID)
         axios({
          url: this.apiUrl + 'doodhvale/api/web/v3/users/signup',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          // this.isLoading = false
          if (response.data.status === '000000' || response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000007' || response.data.status === '000012') {
            //this.isSignUp = true
             if (response.data.status === '000000' && response.data.is_profile === 1) {
              // first login case
              this.resendotp()
              this.isSignUp = true
              this.scrollToTop()
            } else {
              this.resendotp()
              this.isSignUp = true
              this.scrollToTop()
            } 
          } else {
              this.$swal({
              customClass: {
                popup: 'custom-swal-popup',
                confirmButton:'mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn'
              },
              text: response.data.msg,
              allowOutsideClick: false
            })
          }
          // console.log(response)
          /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            //alert(this.list)
          } */
        })
        .catch(e => {
         // alert('not ok')
        }) 
      }
    },

    resendotp () {
      
      const params = new URLSearchParams()
      params.append('mobile', this.mobile)
      axios({
        url: this.apiUrl + 'doodhvale/api/web/v3/users/resend-otp',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {
        }
      })
      .then(response => {
        if (response.data.status !== '000000') {
          //alert(response.data.msg)
        }
        // console.log(response)
        /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          this.list = response.data.user_record
          //alert(this.list)
        } */
      })
      .catch(e => {
        //alert('not ok')
      })
    },

    verifyotp () {
      // debugger
      if (!this.validOTPForm()) {
          return
      } else {
        // this.isLoading = true
        const params = new URLSearchParams()
        var otp = this.otp
        var mobile = this.mobile
        params.append('otp', otp)
        params.append('mobile', mobile)
        axios({
          url: this.apiUrl + 'doodhvale/api/web/v3/users/verify-otp',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          // this.isLoading=false
          if (response.data.status === '000000') {
            this.userId = response.data.user_id
            this.is_profile = response.data.is_profile
            this.getUserInfo()
            this.isMobileVerified = true
            this.isAddressCard = true
            this.showmap = false
            this.isMobCardShow = false
            this.otp = null
            this.scrollToTop()
          } else {
            this.$swal({
              customClass: {
                popup: 'custom-swal-popup',
                confirmButton:'mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn'
              },
              text: response.data.msg,
              allowOutsideClick: false,

            })
          }
          // console.log(response)
          /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            //alert(this.list)
          } */
        })
        .catch(e => {
          //alert('not ok')
        })
      }
    },

    finalCart(){
      
      var products = this.products
      var sub_type = this.subscription_type
      var cart = []

      this.products.forEach(function(product){    
       if(product['quantity'] > 0){
          var temp = {}
          if (sub_type=='Prepaid'){
            temp.product_price = product['prepaid_price']
          } else {
            temp.product_price = product['postpaid_price']
          }
          temp.subscription_id = product.subscription_id
          temp.product_id = product.product_id
          temp.quantity = product.quantity
          temp.product_name = product.product_name
          temp.product_quantity = product.product_price_list[0].quantity
          temp.mrp = product.product_price_list[0].mrp
          temp.product_unit = product.product_price_list[0].unit   
          temp.subscription_type = sub_type
          temp.delivery_frequency = "3"
          temp.type = product.subscription_type
          cart.push(temp)
       }
      });
      this.cart = cart
    },

    submitCart(){
      
      var cart = this.cart
      cart = JSON.stringify(cart)
      const params = new URLSearchParams()

      if (this.ringOnSelected === true) {
        params.append('is_ring_bell', 1)
      } else {
            params.append('is_ring_bell', 0)
      }
      params.append('user_id', this.userId)
      params.append('products', cart)
      params.append('start_date',this.start_date)
      
      axios({
        url: this.apiUrl + 'doodhvale/api/web/v3/subscriptions/multi-subscription',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {
        }
      })
      .then(response => {
        
        if (response.data.status === '000000') {
            this.isFinalCart = false
            this.$swal({
            icon: 'success',
            customClass: {
            popup: 'custom-swal-popup',
            confirmButton:'mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn'
            },
            text: 'Congrats! You Have Subscribe Successfully',
            allowOutsideClick: false
            }).then((result) => {
              if (result.value) {
              this.$router.go()
              } else {
              }
              })
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          }
        } else{
            this.isFinalCart = false
            // debugger
            this.isInformationalCard = true
            this.updatedProdList = response.data.updated_prod_list
        }
      })
      .catch(e => {
        //alert('not ok')
      })
    },

    fetchData () {
      const params = new URLSearchParams()
      var fullUrl = this.payment_url
      var splitUrl = fullUrl.split('pp?')
      params.append('url_str', splitUrl[1])
      axios({
        url:this.apiUrl + 'doodhvale/api/web/v3/accounts/fetch-url-interface-data',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {
        }
      })
      .then(response => {
        this.urlInterface = {}
        if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
          this.urlInterface.error_msg = response.data.msg
          if (document.getElementById('url_valid') !== null) {
            document.getElementById('url_valid').style.display = 'none'
          }
        } else {
          if (document.getElementById('url_expired') !== null) {
            document.getElementById('url_expired').style.display = 'none'
          }
          this.urlInterface.action_name = response.data.action_name
          this.urlInterface.url_interface_id = response.data.url_interface_id
          this.urlInterface.vue_url = this.vueUrl
          this.urlInterface.callback_url = this.apiUrl +  'doodhvale/api/modules/v3' + '/controllers/pgResponse.php'
          var see = this.urlInterface.callback_url
          this.invokeUrlAction()
        }
        // console.log(response)
        /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          this.list = response.data.user_record
          //alert(this.list)
        } */
        setTimeout(() => {
          if (document.getElementById('bafore_checksum') !== null) {
            document.getElementById('bafore_checksum').style.display = 'block'
          }
          this.isLoading = false
        }, 10000)
      })
      .catch(e => {
        if (document.getElementById('bafore_checksum') !== null) {
          document.getElementById('bafore_checksum').style.display = 'block'
        }
        this.isLoading = false
        //alert('not ok')
      })
    },
    

    invokeUrlAction () {
      const params = new URLSearchParams()
      params.append('url_interface_id', this.urlInterface.url_interface_id)
      params.append('action_name', this.urlInterface.action_name)
      axios({
        url: this.apiUrl + 'doodhvale/api/web/v3/accounts/invoke-url-action',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {
        }
      })
      .then(response => {
        if (response.data.action_response.user_id === null || response.data.action_response.user_id === 0 || response.data.action_response.user_id === '0' || response.data.action_response.user_id === 'undefined') {
          window.location.reload()
        }
        this.apiDataObj = {}
        switch (this.urlInterface.action_name) {
          case 'cow_milk_bill':
              // for cow milk billing
            break
          case 'pending_bill_payment':
          // console.log(response)
            this.apiDataObj.userId = response.data.action_response.user_id
            this.apiDataObj.payment_gateway = response.data.action_response.payment_gateway
            this.apiDataObj.app_payment_gateway = response.data.action_response.app_payment_gateway
            this.apiDataObj.pending_amount = Math.ceil(response.data.action_response.pending_amount)
            // console.log(response.data.action_response.is_quick_payment_button_display)
            this.isQuickPaymentButtonDisplay = response.data.action_response.is_quick_payment_button_display
            if (this.isQuickPaymentButtonDisplay === 0) {
              this.fiveDeliveryAmount = response.data.action_response.five_deliveries_amount
              this.sevenDeliveryAmount = response.data.action_response.seven_deliveries_amount
              this.fifteenDeliveryAmount = response.data.action_response.fifteen_deliveries_amount
              this.thirtyDeliveryAmount = response.data.action_response.thirty_deliveries_amount
              this.fourtyFiveDeliveryAmount = response.data.action_response.fourty_five_deliveries_amount
              this.sixtyDeliveryAmount = response.data.action_response.sixty_deliveries_amount
              this.ninetyDeliveryAmount = response.data.action_response.ninety_deliveries_amount
            }
            // this.apiDataObj.pending_amount = -5
            this.apiDataObj.wallet_amount = 0
            if (this.apiDataObj.pending_amount > 0) {
              if (document.getElementById('not_pending') !== null) {
                document.getElementById('not_pending').style.display = 'none'
              }
              if (document.getElementById('clear') !== null) {
                document.getElementById('clear').style.display = 'none'
              }
            } else {
              if (document.getElementById('pending') !== null) {
                document.getElementById('pending').style.display = 'none'
              }
              if (document.getElementById('clear') !== null) {
                document.getElementById('clear').style.display = 'none'
              }
              this.apiDataObj.wallet_amount = Math.abs(this.apiDataObj.pending_amount)
              this.apiDataObj.pending_amount = 0
            }
            this.apiDataObj.default_amount = this.apiDataObj.pending_amount
            //this.pendingBillPayment()
            break
          case 'order_flow_payment':
            // console.log(response)
            this.apiDataObj.userId = response.data.action_response.user_id
            this.apiDataObj.payment_gateway = response.data.action_response.payment_gateway
            this.apiDataObj.app_payment_gateway = response.data.action_response.app_payment_gateway
            this.apiDataObj.pending_amount = Math.ceil(response.data.action_response.pending_amount)
            this.apiDataObj.default_amount = Math.ceil(response.data.action_response.default_amount)
            // this.apiDataObj.pending_amount = -5
            this.apiDataObj.wallet_amount = 0
            if (this.apiDataObj.pending_amount > 0) {
              if (document.getElementById('not_pending') !== null) {
                document.getElementById('not_pending').style.display = 'none'
              }
              if (document.getElementById('clear') !== null) {
                document.getElementById('clear').style.display = 'none'
              }
            } else {
              if (document.getElementById('pending') !== null) {
                document.getElementById('pending').style.display = 'none'
              }
              if (document.getElementById('clear') !== null) {
                document.getElementById('clear').style.display = 'none'
              }
              this.apiDataObj.wallet_amount = Math.abs(this.apiDataObj.pending_amount)
              this.apiDataObj.pending_amount = 0
            }
            //this.pendingBillPayment()
            break
          default:
            break
        }
        /* if (this.apiDataObj.default_amount > 0) {
          this.btnOneValue = ((parseInt(this.apiDataObj.default_amount / 500)) + 1) * 500
          this.btnTwoValue = this.btnOneValue + 500
          this.btnThreeValue = this.btnOneValue + 1000
        }*/
        // console.log(response)
        /* if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
          this.list = response.data.user_record
         // alert(this.list)
        } */
        // this.isFinalCart = false
        // this.isPaymentCard = true
      })
      .catch(e => {
        //alert('not ok')
      })
    },

      btnOneClick () {
        document.getElementById('txn_amt').value = this.btnOneValue
      },

      btnTwoClick () {
        document.getElementById('txn_amt').value = this.btnTwoValue
      },

      btnThreeClick () {
        document.getElementById('txn_amt').value = this.btnThreeValue
      },
      btnFourClick () {
        document.getElementById('txn_amt').value = this.btnFourValue
      },
      
      fiveDeliveryBtnClick () {
        document.getElementById('txn_amt').value = this.fiveDeliveryAmount
      },

      sevenDeliveryBtnClick () {
        document.getElementById('txn_amt').value = this.sevenDeliveryAmount
      },

      fifteenDeliveryBtnClick () {
        document.getElementById('txn_amt').value = this.fifteenDeliveryAmount
      },

      thirtyDeliveryBtnClick () {
        document.getElementById('txn_amt').value = this.thirtyDeliveryAmount
      },

      fourtyFiveDeliveryBtnClick () {
        document.getElementById('txn_amt').value = this.fourtyFiveDeliveryAmount
      },

      sixtyDeliveryBtnClick () {
        document.getElementById('txn_amt').value = this.sixtyDeliveryAmount
      },

      ninetyDeliveryBtnClick () {
        document.getElementById('txn_amt').value = this.ninetyDeliveryAmount
      },

      onAmmountChange () {
        this.errors = ''
        this.isActive = false
        document.getElementById('txn_amt').value = Number(document.getElementById('txn_amt').value)
      },
      generateChecksum () {
        
        sessionStorage.setItem('paymentFlow', 'trialoffer')
        sessionStorage.setItem('userId', this.userId)
        //this.cart = JSON.stringify(this.cart)
        sessionStorage.setItem('cart', JSON.stringify(this.cart) )
        sessionStorage.setItem('ringOnSelected', this.ringOnSelected)
        sessionStorage.setItem('start_date', this.start_date)
        sessionStorage.setItem('required_wallet_amount', this.reqWallAmt)
        if (this.payment_type === '1') {
          this.paytm()
        } else {
          if (this.apiDataObj.app_payment_gateway === '1') {
            this.paytm()
          } else {
            this.hdfc()
          }
        }
      },
      paytm () {
        //debugger
        const params = new URLSearchParams()
        var userId = this.apiDataObj.userId
        // var txnAmount = document.getElementById('txn_amt').value
        var txnAmount = this.rechargeAmt
        if (isNaN(txnAmount) || txnAmount <= 0 || txnAmount === '') {
          document.getElementById('txn_amt').focus()
          this.errors = 'Oops! Invalid Amount.'
          this.isActive = true
        } else {
          this.isLoading = true
          var orderId = 'DVWP' + Math.floor(Math.random() * 10000000)
          params.append('CUST_ID', userId)
          params.append('ORDER_ID', orderId)
          params.append('CHANNEL_ID', 'WEB')
          params.append('WEBSITE', 'SanjeeWEB')
          // params.append('WEBSITE', 'APP_STAGING')// staging
          params.append('TXN_AMOUNT', txnAmount)
          params.append('MERC_UNQ_REF', userId + 'br' + this.urlInterface.vue_url + 'br' + this.apiUrl + 'doodhvale/api/web/v3' + '/accounts/verify-transaction')
          params.append('CALLBACK_URL', this.urlInterface.callback_url)
          axios({
            url: this.apiUrl + 'doodhvale/api/web/v3' + '/accounts/generate-checksum',
            method: 'post',
            data: params,
            withCredentials: false,
            headers: {
            }
          })
          .then(response => {
            this.genChecksum = {}
            this.genChecksum.MID = response.data.post_value.MID
            this.genChecksum.ORDER_ID = response.data.post_value.ORDER_ID
            this.genChecksum.CUST_ID = response.data.post_value.CUST_ID
            this.genChecksum.INDUSTRY_TYPE_ID = response.data.post_value.INDUSTRY_TYPE_ID
            this.genChecksum.CHANNEL_ID = response.data.post_value.CHANNEL_ID
            this.genChecksum.WEBSITE = response.data.post_value.WEBSITE
            this.genChecksum.TXN_AMOUNT = response.data.post_value.TXN_AMOUNT
            this.genChecksum.CALLBACK_URL = response.data.post_value.CALLBACK_URL
            this.genChecksum.MERC_UNQ_REF = response.data.post_value.MERC_UNQ_REF
            this.genChecksum.checksum = response.data.checkSum
            this.isFinalCart = false
            this.isPaymentCard = true
            this.app_payment_gate = false
            this.userData = false
            this.after_checksum = true
            setTimeout(function(){ document.getElementById("paytmFormSubmit").submit() }, 300);
            
            /* console.log(response)
            if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
              this.list = response.data.user_record
              alert(this.list)
            } */
          })
          .catch(e => {
            //alert('not ok')
          })
          this.isLoading = false
        }
      },
      hdfc () {
        // var userId = this.apiDataObj.userId
        var txnAmount = Number(this.rechargeAmt)
        if (isNaN(txnAmount) || txnAmount <= 0 || txnAmount === '') {
          document.getElementById('txn_amt').focus()
          this.errors = 'Oops! Invalid Amount.'
          this.isActive = true
        } else {
          this.isLoading = true
          this.appPaymentGateway = {}
          this.appPaymentGateway.TXN_AMOUNT = txnAmount
          this.appPaymentGateway.ORDER_ID = 'DVWH' + Math.floor(Math.random() * 10000000)
          this.appPaymentGateway.TID = new Date().getTime()
          this.appPaymentGateway.CALLBACK_URL = this.urlInterface.vue_url
          this.appPaymentGateway.APP_PAYMENT_GATEWAY = this.apiDataObj.app_payment_gateway
          this.appPaymentGateway.actionUrl = this.apiUrl + 'doodhvale/api/modules/v3' + '/controllers/ccavRequestHandler.php'
          this.appPaymentGateway.responseUrl = this.apiUrl + 'doodhvale/api/modules/v3' + '/controllers/ccavResponseHandler.php'
          this.appPaymentGateway.apiUrl = this.apiUrl + 'doodhvale/api/web/v3' + '/accounts/payment-gateway-transaction'
          this.isFinalCart = false
          this.isPaymentCard = true
          this.after_checksum = false
          this.userData = false
          this.app_payment_gate = true
          setTimeout(function(){ document.getElementById("hdfcFormSubmit").submit() }, 300);
        }
        this.isLoading = false
      },
      isNumber: function (evt) {
        if (!evt) {
          evt = window.event
        }
        // evt = (evt) ? evt : window.event
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
      },

      loadPaymentGatewayData () {
        // debugger
        const params = new URLSearchParams()
        // this.isLoading = true
        params.append('action_name', 'order_flow_payment_url')
        params.append('user_id', this.userId)
        params.append('required_amount', this.rechargeAmt)
        axios({
          url: this.apiUrl + 'doodhvale/api/web/v3' + '/users/invoke-user-action',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          // console.log(response)
          this.payment_url = response.data.payment_url
          this.fetchData()
        })
        .catch(e => {
          //alert('not ok')
        })
      },

      verifySubscription(){
        // debugger
        var cart = this.cart
        cart = JSON.stringify(cart)
        const params = new URLSearchParams()
  
        if (this.ringOnSelected === true) {
          params.append('is_ring_bell', 1)
        } else {
              params.append('is_ring_bell', 0)
        }
        params.append('user_id', this.userId)
        params.append('products', cart)
        params.append('start_date',this.start_date)
        params.append('total_amount', this.total_price_after_discount)
        
        axios({
          url: this.apiUrl + 'doodhvale/api/web/v3/subscriptions/multi-subscription-verification',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          // debugger
          if (response.data.status_code === '000000') {
              // this.submitCart()
              this.walletBal = response.data.walletBal
              this.rechargeAmt = 0
              // debugger
          } else if (response.data.status_code == '000005') {
          // alert(str)
            //  this.$swal({
            //       text: response.data.msg,
            //       showCancelButton: true, 
            //       customClass: 'custom-swal',
            //       confirmButtonColor: "#3085d6",
            //       confirmButtonText: "Recharge",
            //       confirmButtonColor: "#3085d6",
            //       cancelButtonText: 'Cancel',
            //       allowOutsideClick: false
            //   }).then((result) => {
              this.reqWallAmt = response.data.totalRequiredWalletAmt
              this.rechargeAmt = response.data.rechargeAmt
              this.msg = response.data.msg
              this.walletBal = response.data.walletBal
              // if (result.value) { 
                // debugger
              this.loadPaymentGatewayData()
              // } else {
              //   // this.$swal('Success', 'Thanks you Replan!', 'success')
              // }
              // })
          // } else {
          //   // alert(response.data.msg)
          //   // alert(str)
          //   this.$swal({
          //     text: str + '!',
          //     customClass: 'custom-swal',
          //     showCancelButton: false,
          //     confirmButtonText: 'Okay',
          //     allowOutsideClick: false
          //     // showCloseButton: true,
          //     // showLoaderOnConfirm: true
          //   }).then((result) => {})
          }
        })
        .catch(e => {
          //alert('not ok')
        })
    },
    handleOnComplete(value) {
      this.otp = value
    },

    handleOnChange(value) {
    },

    // handleClearInput() {
    //   this.$refs.otpInput.clearInput();
    // },
  
    updateProfileAddress () {
      // debugger
        if (document.getElementById('headerLat').value === '') {
          this.editLocation()
          setTimeout(function() {document.getElementById('madal-error-address').style.display = 'block'}, 100)
          // document.getElementById('madal-error-address').style.display = 'block
          return
        }
      if (!this.validate() == true){
        return
      }
      // debugger
      this.searchAddress = document.getElementById('searchAddress').innerHTML
      if(this.userDetails.first_name === '' || this.userDetails.first_name === undefined ){
          this.$swal({
              customClass: {
              popup: 'custom-swal-popup',
              confirmButton:'mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn'
              },
              text: "Please Enter Name",
              allowOutsideClick: false
            })
          return
        }
      // if(this.userDetails.email === '' || this.userDetails.email === undefined ){
      //   this.$swal({
      //       customClass: 'custom-swal',
      //       text: "Please Enter Email",
      //       allowOutsideClick: false
      //     })
      //     return
      // }
      if (document.getElementById('address1').value !== '') {
        this.address1 = document.getElementById('address1').value
        this.address2 = document.getElementById('address2').value
        //if (sessionStorage.getItem('actionName') === 'subscription') {
          const params = new URLSearchParams()
          var userId = this.userId
          var userDetails = this.userDetails
            this.userDetails.fullName = userDetails.first_name
            this.custName = userDetails.first_name
            // if (document.getElementById('searchAddress').innerHTML == '' /*|| this.formattedAddress == ''*/) {
            //   this.userDetails.address = this.address1 + ' ' + this.address2 + ', ' + this.city + ', ' + this.state + ', ' + this.pincode
            // }else{
             this.userDetails.address =  this.address1 + ', '+ document.getElementById('searchAddress').innerHTML
             this.formattedAddress = document.getElementById('searchAddress').innerHTML
             this.markers[0].position.lat = document.getElementById('headerLat').value
             this.markers[0].position.lng = document.getElementById('headerLng').value
            //  this.fillAddress(this.markers[0].position.lat,this.markers[0].position.lng)
            //}
             // debugger
             this.custAddress = this.userDetails.address
            params.append('user_id', userId)
            params.append('first_name', userDetails.first_name)
            params.append('pincode', this.pincode)
            params.append('address1', this.address1)
            params.append('address2', this.address2)
            params.append('state', this.state)
            params.append('gps_address', this.formattedAddress)
            // if (this.markers[0].position.lat) {
              params.append('latitude', this.markers[0].position.lat)
              params.append('longitude', this.markers[0].position.lng)
            // } else {
            //   params.append('latitude', 0.0)
            //   params.append('longitude', 0.0)
            // }
            params.append('locality', this.locality)
            params.append('region_code', this.pincode)
            params.append('phone', this.mobile)
            params.append('email', userDetails.email)
            params.append('zombie', 0)
            params.append('country_id', 1)
            //debugger
            axios({
              url: this.apiUrl + 'doodhvale/api/web/v3/users/profile',
              method: 'post',
              data: params,
              withCredentials: false,
              headers: {
              }
            })
            .then(response => {
              // console.log(response)
              if (response.data.status === '000000') {
                // window.location.href = sessionStorage.getItem('callbackUrlForSubscription')
                // debugger
                this.finalCart()
                if (this.subscription_type=='Prepaid'){
                     this.verifySubscription()
                }
                this.isAddressCard = false
                this.isFinalCart = true
                this.scrollToTop()
              } else {
                this.$swal({
                customClass: {
                popup: 'custom-swal-popup',
                confirmButton:'mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn'
                },
                text: response.data.msg,
                allowOutsideClick: false
              }) 
              }
            })
            .catch(e => {
              //console.log(e)
            })
        
      } else {
        // alert('Please fill address')
          this.$swal({
          customClass: {
          popup: 'custom-swal-popup',
          confirmButton:'mat-raised-button btn btn-info btn-round btn-lg btn-block dv-primary-btn'
          },
          text: 'Please Enter H. NO | FLOOR | LOCALITY | AREA!',
          allowOutsideClick: false,
        })
      }
    },

    getUserInfo() {
    
      const params = new URLSearchParams()
      params.append('user_id', this.userId)
      axios({
        url: this.apiUrl + 'doodhvale/api/web/v3/users/user-info',
        method: 'post',
        data: params,
        withCredentials: false,
        headers: {
        }
      })
      .then(response => {
        //debugger
        if (response.data.status == '000000') {
          var self = this
          if(self.is_profile === 0){
            self.userDetails = response.data.user_record.user_details
          self.userDetails.fullName = response.data.user_record.user_details.first_name + ' ' + response.data.user_record.user_details.last_name
            self.address1 = response.data.user_record.address.address1
            self.address2 = response.data.user_record.address.address2
            self.city = response.data.user_record.address.city
          self.userDetails.city = response.data.user_record.address.city
          self.userDetails.state = response.data.user_record.address.state
          self.userDetails.address = self.address1 + ' ' + self.address2 + ' ' + self.userDetails.city + ' ' + self.userDetails.state + ' ' + self.userDetails.pincode
          self.custName = self.userDetails.fullName
          self.custAddress = self.userDetails.address
          self.userDetails.fullName = self.userDetails.fullName.replace(/[^a-zA-Z0-9 ]/g, '')
          self.userDetails.address = self.userDetails.address.replace(/[^a-zA-Z0-9 ]/g, '')
            self.markers[0].position.lat = parseFloat(response.data.user_record.address.latitude)
            self.markers[0].position.lng = parseFloat(response.data.user_record.address.longitude)
            self.center.lat = parseFloat(response.data.user_record.address.latitude)
            self.center.lng = parseFloat(response.data.user_record.address.longitude)
            document.getElementById('headerLat').value = self.markers[0].position.lat
              document.getElementById('headerLng').value = self.markers[0].position.lng
              document.getElementById('hfullAddress').value = response.data.user_record.address.gps_address
            self.address(self.markers[0].position.lat, self.markers[0].position.lng)
            if (document.getElementById('searchAddress')) {
              document.getElementById('searchAddress').innerHTML = response.data.user_record.address.gps_address

            }
        } else {
          if(document.getElementById('headerLat').value !== ''){
            let latitude = document.getElementById('headerLat').value
            let longitude = document.getElementById('headerLng').value
            let hfullAddress = document.getElementById('hfullAddress').value
            self.center = {
              lat: latitude,
              lng: longitude
            };
            self.markers[0].position.lat = latitude
            self.markers[0].position.lng = longitude
            hfullAddress = hfullAddress.replace(/\s+/g, '+');
            axios.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + hfullAddress + "&key=AIzaSyArGgueGCb2p4sqjU4pScADLskS9OxZ8jQ")
          .then((response) => {
            // Ideally you'd search for the index with type = sublocality in address_components
            this.fillAddress(response.data.results)
          })  
          }else{
            this.currentlocation()
          }
          
        }
        this.isLoading=false
        }
        else{
          if(document.getElementById('headerLat')){
              let latitude = document.getElementById('headerLat').value
              let longitude = document.getElementById('headerLng').value
              let hfullAddress = document.getElementById('hfullAddress').value
              this.center = {
                lat: latitude,
                lng: longitude
              };
              if ((typeof this.markers[0].position.lat != 'undefined' && typeof this.markers[0].position.lng != 'undefined')){
                latitude = this.markers[0].position.lat
                longitude = this.markers[0].position.lng
              } else {
              this.markers[0].position.lat = latitude
              this.markers[0].position.lng = longitude
              }
              hfullAddress = hfullAddress.replace(/\s+/g, '+');
              axios.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + hfullAddress + "&key=AIzaSyArGgueGCb2p4sqjU4pScADLskS9OxZ8jQ")
            .then((response) => {
              // Ideally you'd search for the index with type = sublocality in address_components
              this.fillAddress(response.data.results)
            }) 
            }
        }
      })
      .catch(e => {
        //alert('not ok')
      })
    },
  }
};
</script>

